import React, { Component } from 'react'
import Control from 'react-leaflet-control';
import { Table, Button } from 'reactstrap';
import Moment from 'react-moment';
import foto_kapal from 'assets/img/kapal.jpg';
import './legend.css'
import { UPLOAD_URL } from 'actions/constant'

class Legend extends Component {
  render() {
    return (
      <Control position="bottomright" className="legend-info">
        <Table striped className="legend-table">
          <tbody>
            <tr>
              <td colSpan="2" >
                <img src={
                  this.props.data.photo ? UPLOAD_URL + this.props.data.photo : foto_kapal
                  } className=" mb-3" width="250px" />
                <h6>{this.props.data.name}</h6>
              </td>
            </tr>
            <tr>
              <td>Trayek</td>
              <td></td>
            </tr>
            
            <tr>
              <td>Asal</td>
              <td>{this.props.data.dari_pelabuhan}</td>
            </tr>
            <tr>
              <td>Tujuan</td>
              <td>{this.props.data.ke_pelabuhan}</td>
            </tr>
            <tr>
              <td>ETD</td>
              <td><Moment format="DD MMMM YYYY">{this.props.data.tanggal_berangkat}</Moment></td>
            </tr>
            <tr>
              <td>ETA</td>
              <td><Moment format="DD MMMM YYYY">{this.props.data.tanggal_tiba}</Moment></td>
            </tr>
            <tr>
              <td>Jumlah Muatan</td>
              <td></td>
            </tr>
            <tr>
              <td>ATD</td>
              <td></td>
            </tr>
            <tr>
              <td>ATA</td>
              <td></td>
            </tr>
            <tr>
              <td>Speed</td>
              <td></td>
            </tr>
            <tr>
              <td>
                <Button size="md"
                  color="success"
                  className="mr-2"
                  onClick={() => { this.props.backFunction() }}>Kembali</Button>
              </td>
            </tr>
          </tbody>
        </Table>
      </Control>
    )
  }
}

export default Legend